import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "volume-1",
  "use": "volume-1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-volume-1\" id=\"volume-1\"><polygon points=\"11 5 6 9 2 9 2 15 6 15 11 19 11 5\" /><path d=\"M15.54 8.46a5 5 0 0 1 0 7.07\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol